<template>
  <div class="tw-flex tw-h-screen tw-overflow-hidden">
    <SidebarProvider>
      <AppSideBar />
      <div class="tw-flex-1 tw-flex tw-flex-col tw-bg-[#f9fafd] tw-overflow-hidden">
        <HijackBanner v-if="isHijackSession" />
        <NavBar class="sticky-nav" />
        <div class="tw-flex-1 tw-p-4 tw-overflow-y-auto">
          <RouterView />
        </div>
      </div>
    </SidebarProvider>
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';

import AppSideBar from '@/components/sidebar/AppSideBar.vue';
import NavBar from '@/components/navbar/NavBar.vue';
import { onMounted } from 'vue';
import { useToast } from 'vue-toast-notification';
import { useI18n } from 'vue-i18n';
import tokenService from '@/_helpers/services/token.service';
import { useNotificationsStore } from '@/stores/notifications.store';
import HijackBanner from '@/components/hijack-banner/HijackBanner.vue';
import { SidebarProvider } from '@/components/ui/sidebar';

const { t } = useI18n();
const $toast = useToast();
const { refreshNotificationsState } = useNotificationsStore();
import cookieService from '@/_helpers/services/cookie.service';

const isHijackSession = !!cookieService.get('is_hijack_session');

onMounted(() => {
  openNotificationsConnection();
});

const openNotificationsConnection = () => {
  const wsUrl = import.meta.env.VITE_INOCU_WS_URL;
  if (!wsUrl) {
    $toast.open({
      message: t('notifications.titles.generic_error'),
      type: 'error',
    });
    return;
  }
  const socket = new WebSocket(wsUrl);

  socket.onopen = () => {
    const tokenAsStr = JSON.stringify({
      token: tokenService.getAccessToken(),
      tenant: cookieService.get('tenant'),
    });
    socket.send(tokenAsStr);
  };

  socket.onmessage = async event => {
    const notificationData = JSON.parse(event.data);

    if (notificationData.type === 'notification') {
      $toast.open({
        message: t('notifications.titles.new_notification'),
        type: 'info',
      });

      await refreshNotificationsState(false);
    }
  };

  socket.onerror = () => {
    $toast.open({
      message: t('notifications.titles.generic_error'),
      type: 'error',
    });
  };
};
</script>
